import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  statusDropDown: {
    display: "flex",
    alignItems: "center",
    width: "180px",
    boxSizing: "border-box"
  },
  statusColor: {
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "10px",
    height: "15px",
    width: "15px",
    border: `1px solid ${theme.palette.border.main}`,
  },
  statusColorSmall: {
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "10px",
    height: "10px",
    width: "10px",
    border: `1px solid ${theme.palette.border.main}`,
  },
  animatedIcon: {
    width: "20px !important",
    height: "20px !important",
  },
  input: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "4px 10px",
    width: "160px",
  },
  inputSmall: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "5px 10px",
    fontSize: "14px !important",
    display: "flex",
    alignItems: "center",
    height: "34px"
  },
  menuItem: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export default useStyles;
